import React from 'react'
import { ThemeProvider, Typography, CssBaseline} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from '../../theme.js'
import { TopBar } from '../../components/TopBar/TopBar'
import {Footer} from '../../components/Footer/Footer'
import tiling from '../../images/blue-tile.png'
import banner from '../../images/corporate_banner.jpg'
import bank from '../../images/firstcitizensbank.png'
import johnmuir from '../../images/johnmuir.png'
import levis from '../../images/levis.png'
import solar from '../../images/canadasolar.png'
import { Box } from '@mui/system';
import { CorporateCarousel } from '../../components/Carousel/CorporateCarousel.js';

export const Corporate = () => {
  
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Grid container style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed", alignItems:"stretch"}}>
        <Grid item xs={12}>
          <TopBar/>
        </Grid>
        <Grid item xs={12}>
            <img src={banner} width="100%" alt="banner"/>
        </Grid>
        <Grid item xs={12} textAlign="center" pb={5}>
          <Typography color="white" fontSize={{xs:".8rem", sm:"1rem", md:"1.5rem", lg:"2rem", xl:"2.3rem"}} fontFamily={"Copperplate"}>
          Team building · Success Celebration · Off-site Fun         
           </Typography>
        </Grid>
        <Grid item xs = {12} md={6} display={"flex"} flexDirection={"column"} alignItems={{xs:"center", md:"end"}} justifyContent={"space-between"} px={{sm:5, md:10}} pb={{sm:8}}>
          <img src = {bank} width="50%" alt="bank"/>
          <img src = {johnmuir} width="50%" alt="john muir"/>
          <img src = {levis} width="50%" alt="levis"/>
          <img src = {solar} width="50%" alt="solar"/>
        </Grid>
        <Grid item xs = {12} md={4} p = {{xs:5, md:0}}>
          <Typography color="white" variant = "h5" fontFamily={"Sans-Serif"}>
          Escape games are a fun employee outing and a meaningful team building 
          experience for your company team. Our VR adventures emphasize the 
          importance of working together to problem-solve under time pressure. 
          We'll provide your team with a unique and memorable experience that 
          they'll be talking about for weeks! <br/><br/>
          <ul>
          <li>Private parties get to use the entire space, making this a uniquely exclusive experience!</li> <br/>

          <li>Discounts for 20+ players</li><br/>

          <li>Bring your own food, drinks and cake</li><br/>

          <li>Non-players are also welcome to enjoy the space while others seek adventure in our amazing VR rooms</li><br/>

          <li>Corporate Events are customized to ensure you have the best experience we can offer!</li><br/>

          <li>Play head-to-head and compete for best time</li><br/>

          <li>Custom itinerary for parties up to 40 players</li><br/>
          <li>Great location and easy free parking</li><br/>
          </ul>
        </Typography>
        </Grid>
        <Grid item xs={12} textAlign="center" pt={5}>
          <Typography color="white" variant="h4" fontFamily={"Copperplate"}>
          Ready For Adventure? <br/>Call 925-393-7171        
          </Typography>
        </Grid>
        <Grid item xs={12} textAlign="center" pt={5}>
          <Box sx={{marginX:10,borderTop:1, borderColor:"white"}}>
          <Typography color="white" variant="h5" fontFamily={"Copperplate"} py={5}>
          Team building at Diablo Escapes is AWESOME! <br/> But don't take our word for it...
          </Typography>
          </Box>
        </Grid>
        <Grid item xs={1.5}>

        </Grid>
        <Grid item xs={9}>
          <CorporateCarousel/>
        </Grid>
      <Footer/>
      </Grid>
    </ThemeProvider>
    )
}
